import { PersonasDict } from '@sdk/personaCollection/types/PersonasDict';
import { ShiftFeedbackFromApi } from '@sdk/timesheets/types/ShiftFeedback';
import { TagType } from '@sdk/tags/types/TagType';
import getRealDate from '@sdk/utils/getRealDate';
import formatTime from '@sdk/utils/dateFormat/formatTime';
import type { DayPart } from '@sdk/dayParts/types/apiTypes';

import { ShiftFeedback } from '@web/timesheets/types/ShiftFeedback';

export function mapShiftFeedbackFromApi({
  shiftFeedbackFromApi,
  personasDict,
  knownTagsDict,
  usTimeFormat,
  dayParts,
  belongsToDayPart,
}: {
  shiftFeedbackFromApi: ShiftFeedbackFromApi;
  personasDict: PersonasDict;
  knownTagsDict: Record<number, TagType>;
  usTimeFormat: boolean;
  dayParts: DayPart[];
  belongsToDayPart: (event: { dtstart: Date }, dayPart: DayPart) => boolean;
}): ShiftFeedback {
  const clockInLocal = new Date(shiftFeedbackFromApi.clockIn);
  const clockOutLocal = new Date(shiftFeedbackFromApi.clockOut);
  const tags = shiftFeedbackFromApi.tags.length
    ? shiftFeedbackFromApi.tags.map((tag) => knownTagsDict[tag.id] ?? tag)
    : null;
  const matchingDayParts = dayParts.filter((dayPart) =>
    belongsToDayPart({ dtstart: clockInLocal }, dayPart)
  );

  return {
    id: shiftFeedbackFromApi.id,
    rating: shiftFeedbackFromApi.rating,
    comment: shiftFeedbackFromApi.comment,
    shift: shiftFeedbackFromApi.shift,
    user: personasDict[shiftFeedbackFromApi.user.id] ?? shiftFeedbackFromApi.user,
    location: personasDict[shiftFeedbackFromApi.location.id] ?? shiftFeedbackFromApi.location,
    position: personasDict[shiftFeedbackFromApi.position.id] ?? shiftFeedbackFromApi.position,
    tags,
    clockIn: getRealDate(shiftFeedbackFromApi.clockIn),
    clockInLocal,
    clockOut: getRealDate(shiftFeedbackFromApi.clockOut),
    clockOutLocal,
    clockInOutSummary: `${formatTime(clockInLocal, usTimeFormat)} - ${formatTime(
      clockOutLocal,
      usTimeFormat
    )}`,
    dayPartIds: matchingDayParts.map((dayPart) => dayPart.id),
    dayPartsStringified: matchingDayParts.map((dayPart) => dayPart.name).join(', '),
  };
}
